import { combineReducers } from "redux";

import { categoryDetails } from "./reducer.category"
const categoryReducers = combineReducers({
  categoryDetails
})
export default categoryReducers;
